var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dialog-login",
      on: { click: _vm.dialogCancel, touchmove: _vm.dialogCancel },
    },
    [
      _c("div", { staticClass: "login-content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "login-text-bold" }, [_vm._v("点赞成功")]),
        _vm._v(" "),
        _c("div", { staticClass: "login-text" }, [
          _vm._v("登录参与更多精彩互动"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "login-href",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.loginHref($event)
              },
            },
          },
          [_vm._v("登录查看我赞过的文章")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "login-cancel" }, [_vm._v("取消")]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-image" }, [
      _c("img", { attrs: { src: "//statics.itc.cn/WAP_base/right.png" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }